module.exports = __webpack_public_path__ + "assets/29ccb0b35e7e8443adcbfca2428a039e.png";